import { useEffect, useState } from 'react';

import type { User } from '../@types/user';
import { LIVE_CHAT_KEY, LIVE_CHAT_URL } from '../constants/env';
import { initSDK, setUser, type ChatwootConfig } from '../libs/chatwoot';

const DEFAULT_CONFIG: ChatwootConfig = {
    showPopoutButton: true,
    hideMessageBubble: true,
    position: 'right',
    type: 'standard',
    launcherTitle: 'แจ้งปัญหากับเรา',
    locale: 'th',
    useBrowserLanguage: false,
    darkMode: 'dark',
    baseDomain: '.xver.cloud',
};

let sdkReady = false;
const readyListeners: Array<() => void> = [];

const onReady = () => {
    sdkReady = true;
    readyListeners.forEach((fn) => fn());
};

export const initChatwootSDK = () => {
    if (!LIVE_CHAT_URL || !LIVE_CHAT_KEY) return;

    initSDK(DEFAULT_CONFIG)
        .then(onReady)
        .catch((err) => console.error('Chatwoot init failed:', err));
};

export const useChatwoot = (user: User | undefined) => {
    const [ready, setReady] = useState(sdkReady);

    useEffect(() => {
        if (sdkReady) {
            setReady(true);
            return;
        }
        readyListeners.push(() => setReady(true));
    }, []);

    useEffect(() => {
        if (ready && user) {
            setUser(user);
        }
    }, [ready, user]);
};
